export enum RouteDataNamesEnum {
  PRELOAD = 'preload',
}
